import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const getVendorExpenseQuery = (values) => {
    const config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}` || null
        }
    };
    return axios.get(`${apiurl?.getVendorExpenseitem}/${values.expenseCategoryId}/${values.vendorId}`, config);
};

export default getVendorExpenseQuery;
